module.exports = __webpack_public_path__ + "assets/life_confirm_v1.95d739e8.svg";